import { httpService } from '@/api/v1/http.service'
import useDownload, { type DownloadParams } from '@/hooks/useDownload'
import { formatApiDate } from '@/utils/format-date'
import { parseColumnsToFetchKeys } from '@/utils/parse-columns-to-fetch-keys'

import { type LessonsParams } from '../queries/useLessons'

export type LessonsDownloadParams = DownloadParams & LessonsParams

const useLessonsDownload = (lessonsDownloadParams: LessonsDownloadParams) =>
  useDownload({
    fileName: 'users',
    requestParams: lessonsDownloadParams,
    // @ts-expect-error Waits for backend fix - file type should be returned
    downloadMutation: (params: LessonsDownloadParams) =>
      httpService.panel.panelLessonsList(
        {
          is_covered: params.isCovered,
          is_cancelled: params.isCancelled,
          show_past_data: !!params.showPastData,
          any_teacher_id: params.teacherIds,
          class_id: params.classIds,
          course_id: params.courseIds,
          group_id: params.groupIds,
          date_after: params.dateAfter
            ? formatApiDate(new Date(params.dateAfter))
            : undefined,
          date_before: params.dateBefore
            ? formatApiDate(new Date(params.dateBefore))
            : undefined,
          semester_id: params.semesterId,
          format: params.format,
          fetchKeys: parseColumnsToFetchKeys(params.columnsKey, params.format)
        },
        { format: 'blob' }
      )
  })

export default useLessonsDownload
